<template>
  <div class="searchtar">
    <div class="searchtar-form"
         v-loading="loading"
         element-loading-text="查询数据包中">
      <el-form ref="form"
               size="mini"
               label-width="100px"
               label-position="right">
        <el-form-item label="工厂">
          <el-autocomplete class="el-input"
                           v-model="factoryName"
                           :fetch-suggestions="searchFactory"
                           placeholder="请选择工厂"
                           clearable>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="检测机">
          <el-autocomplete class="el-input"
                           v-model="machineId"
                           :fetch-suggestions="searchMachine"
                           placeholder="请选择机器"
                           clearable>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="起始日期"
                      style="width:430px;">
          <el-date-picker v-model="dateRange"
                          type="daterange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          size="mini"
                          :clearable="false"
                          :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="机器状态">
          <el-select class="el-input"
                     v-model="machineStatus"
                     placeholder="请选择机器状态">
            <el-option :value="''"
                       label="不指定"></el-option>
            <el-option value="S0"
                       label="S0"></el-option>
            <el-option value="S3"
                       label="S3"></el-option>
            <el-option value="S4"
                       label="S4"></el-option>
            <el-option value="S5"
                       label="S5"></el-option>
            <el-option value="S6"
                       label="S6"></el-option>
            <el-option value="S8"
                       label="S8"></el-option>
            <el-option value="S9"
                       label="S9"></el-option>
            <el-option value="SC"
                       label="SC"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="我的标注状态">
          <el-select class="el-input"
                     v-model="myLabellingStatus"
                     placeholder="请选择状态">
            <el-option :value="''"
                       label="不指定"></el-option>
            <el-option value="NotLabeled"
                       label="未标注"></el-option>
            <el-option value="Pending"
                       label="等待审核"></el-option>
            <el-option value="Rejected"
                       label="驳回"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="$route.name==='review'"
                      label="过滤审核状态">
          <el-select class="el-input"
                     v-model="reviewStatus">
            <el-option :value="''"
                       label="不过滤"></el-option>
            <el-option value="Pending"
                       label="待审核"></el-option>
            <!-- <el-option value="Passed"
                       label="已通过"></el-option>
            <el-option value="Rejected"
                       label="已驳回"></el-option>
            <el-option value="Reviewed"
                       label="审核完成"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>
      <el-button type="primary"
                 style="width:100%;margin-bottom:10px;"
                 size="mini"
                 @click="search">查询</el-button>
    </div>
    <div class="searchtar-result">
      <el-input placeholder="正则二次搜索（仅搜索当页数据）"
                class="input-with-select"
                size="small"
                v-model="searchText"
                clearable>
      </el-input>
      <div class="tarlist">
        <div class="tarlist-item"
             v-for="(tar,idx) in filteredTarList"
             :class="{active:tarId===tar.tarId}"
             :key="tar.tarId"
             @dblclick="useTar(tar.tarId)">
          <span class="idx">#{{Number((page-1)*limit)+idx+1}}</span>
          <span class="tarid">{{tar.tarId}}</span>
          <span class="machinealias">{{tar.machineAlias}}</span>
          <div
               style="display:flex;justify-content:space-between;align-items:center;margin:5px 0 0;">
            <div>
              <TarTag :type="tar.myLabellingStatus">我的标注:</TarTag>
              <TarTag :type="tar.tarReviewStatus"
                      v-show="$route.name==='review'">审核:</TarTag>
            </div>
          </div>
          <div
               style="display:flex;justify-content:space-between;align-items:center;margin:5px 0 0;">
            <div>
              <!-- <el-button type="info"
                         size="mini"
                         v-show="cached[tar.ossPath]!=='cached'"
                         @click="cache(tar.ossPath)">加入缓存{{cached[tar.ossPath]==='pending'?'中':''}}<i
                   v-show="cached[tar.ossPath]==='pending'"
                   class="el-icon-loading"></i>
              </el-button> -->
              <i class="el-icon-star-on"
                 v-if="marked[tar.ossPath]==='marked'"
                 @click.prevent="setUnmarked(tar.ossPath)"
                 style="color:red;"></i>
              <i class="el-icon-star-off"
                 v-else
                 @click.prevent="setMarked(tar.ossPath)"></i>
            </div>
            <div>
              <el-button type="success"
                         size="mini"
                         v-clipboard="tar.machineAlias+' '+tar.tarId">复制 ID</el-button>
              <el-button size="mini"
                         @click="useTar(tar.tarId)"
                         :disabled="isLoading">使用</el-button>
            </div>
          </div>
        </div>
      </div>
      <el-pagination :current-page.sync="page"
                     :page-size="limit"
                     :pager-count="5"
                     layout="pager, jumper"
                     :total="totalCount">
      </el-pagination>
    </div>
    <div style="margin-top:5px;">
      <el-input ref="specifiedTarID"
                placeholder="请输入指定的 TarID"
                v-model.trim="specifiedTarID"
                size="small"
                class="input-with-select"
                @focus="selectAllTarID"
                @keydown.enter.native="useSpecifiedTarID"
                clearable>
        <el-button slot="append"
                   @click="useSpecifiedTarID">使用</el-button>
      </el-input>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import TarTag from '@/components/TarTag'
import store from 'store'

export default {
  data() {
    return {
      loading: false,
      specifiedTarID: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()])
            },
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近七天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  created() {
    this.page = store.get('search:page') || 0
    this.factoryName = store.get('search:factoryName') || ''
    this.machineId = store.get('search:machineId') || ''
    this.dateRange = store.get('search:dateRange') || [new Date(), new Date()]
    this.myLabellingStatus = store.get('search:myLabellingStatus') || ''
    this.machineStatus = store.get('search:machineStatus') || ''
    this.reviewStatus = store.get('search:reviewStatus') || ''
    this.searchText = store.get('search:searchText') || ''
  },
  mounted() {
    this.machineId = this.$route.query.machineid || ''
    this.fetchFactory()
    this.fetchAlias()
    this.search()
  },
  computed: {
    ...mapState(['alias']),
    ...mapState('search', ['tarList', 'totalCount', 'factories']),
    ...mapState('mark', ['marked']),
    ...mapGetters(['isLoading']),
    ...mapGetters('search', ['filteredTarList']),
    ...mapFields([
      'search.factoryName',
      'search.machineId',
      'search.startDate',
      'search.endDate',
      'search.limit',
      'search.page',
      'search.searchText',
      'search.myLabellingStatus',
      'search.machineStatus',
      'search.reviewStatus',
      'tarId',
    ]),

    dateRange: {
      get() {
        return [this.startDate, this.endDate]
      },
      set(val) {
        if (this.startDate !== val[0]) this.startDate = val[0]
        if (this.endDate !== val[1]) this.endDate = val[1]
      },
    },
  },
  methods: {
    ...mapMutations('mark', ['setMarked', 'setUnmarked']),
    ...mapActions(['fetchAlias']),
    ...mapActions('search', ['fetchFactory', 'fetchTarList']),
    useTar(tarId) {
      if (this.isLoading) {
        this.$message({
          type: 'warning',
          message: '请等待上一个任务完成',
        })
      } else {
        this.$router.push({ query: { tarid: tarId } })
      }
    },
    search() {
      this.loading = true
      this.fetchTarList(this.$route.name).finally(() => {
        this.loading = false
      })
    },
    searchFactory(qryStr, cb) {
      cb(
        this.factories
          .filter(factory => factory.indexOf(qryStr) !== -1)
          .map(f => ({ value: f })),
      )
    },
    searchMachine(qryStr, cb) {
      cb(
        this.alias
          .filter(aliasItem => aliasItem.alias.indexOf(qryStr) !== -1)
          .map(f => ({ value: f.alias })),
      )
    },
    useSpecifiedTarID() {
      if (this.specifiedTarID) {
        this.$router.push({
          name: this.$route.name,
          query: { ...this.$route.query, tarid: this.specifiedTarID },
        })
      }
    },
    selectAllTarID() {
      this.$refs.specifiedTarID.select()
    },
  },
  watch: {
    page(val) {
      this.search()
      store.set('search:page', val)
    },
    factoryName(val) {
      store.set('search:factoryName', val)
    },
    machineId(val) {
      store.set('search:machineId', val)
    },
    dateRange(val) {
      store.set('search:dateRange', val)
    },
    myLabellingStatus(val) {
      store.set('search:myLabellingStatus', val)
    },
    reviewStatus(val) {
      store.set('search:reviewStatus', val)
    },
    searchText(val) {
      store.set('search:searchText', val)
    },
    specifiedTarID(val) {
      const result = val.match(
        /[0-9a-fA-F]{2}(-[0-9a-fA-F]{2}){5}:\d{6}-\d{6}-[^\s]+/,
      )
      if (result && result[0]) {
        this.specifiedTarID = result[0]
      }
    },
  },
  components: { TarTag },
}
</script>

<style lang="scss" scoped>
.searchtar {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  &-form {
    flex-shrink: 0;
    .el-date-editor {
      width: 330px;
    }
  }
  &-result {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }
}
.tarlist {
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 5px 0;
  flex: 1;
  height: 0;
  overflow: auto;
  font-size: 14px;
  &-item {
    padding: 5px;
    margin: 5px;
    box-shadow: 0 2px 4px #ccc;
    border: 2px solid transparent;
    cursor: pointer;
    border-radius: 4px;
    &:hover {
      background: #eee;
    }
    &.active {
      color: white;
      background: #409eff;
    }
    .idx {
      margin-right: 5px;
      font-weight: bold;
    }
    .tarid {
      margin-right: 5px;
    }
  }
}
</style>
